import { useEffect } from 'react';

export function formatDocumentTitle(baseTitle: string): string {
  return `${baseTitle} | Relcore`;
}

/**
 * Sets the document title and appends the "| Relcore" suffix.
 */
export function useDocumentTitle(baseTitle: string | null | undefined): void {
  useEffect(() => {
    const t = baseTitle?.trim();
    if (!t) {
      return;
    }
    document.title = formatDocumentTitle(t);
  }, [baseTitle]);
}
